module.exports = __webpack_public_path__ + "media/images/metronic/social/klout-2137fc4c765dd01b2bab6685d01dd749.png";